import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import s from './s.module.less';

interface ConfirmModalProps {
    visible: boolean;
    title?: string;
    content?: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
    loading?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    visible,
    title = 'Confirm Delete',
    content = 'Are you sure you want to delete this item? This action cannot be undone.',
    onConfirm,
    onCancel,
    confirmText = 'Delete',
    cancelText = 'Cancel',
    loading = false,
}) => {
    return (
        <Modal
            open={visible}
            title={
                <div className={s.modalTitle}>
                    <ExclamationCircleOutlined className={s.warningIcon} />
                    <span>{title}</span>
                </div>
            }
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={loading}>
                    {cancelText}
                </Button>,
                <Button
                    key="confirm"
                    type="primary"
                    danger
                    onClick={onConfirm}
                    loading={loading}
                >
                    {confirmText}
                </Button>,
            ]}
            width={400}
            centered
        >
            <div className={s.modalContent}>
                <p>{content}</p>
            </div>
        </Modal>
    );
};

export default ConfirmModal;
